var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7705 13.1759L15.7126 22.847H13.064L11.0685 15.1297C10.9457 14.6537 10.8407 14.4806 10.4723 14.2785C9.8689 13.9526 8.87636 13.647 8 13.4566L8.06133 13.1759H12.3226C12.866 13.1759 13.3546 13.538 13.4775 14.1621L14.5326 19.7596L17.1388 13.1759L19.7705 13.1759ZM30.145 19.688C30.1567 17.1369 26.6107 16.9981 26.6361 15.8568C26.643 15.5084 26.9736 15.1398 27.6977 15.0467C28.0572 14.9989 29.0466 14.9639 30.168 15.4781L30.6075 13.4282C30.0041 13.2095 29.2286 13 28.2647 13C25.789 13 24.0461 14.3152 24.0314 16.1971C24.0152 17.5887 25.2749 18.3653 26.225 18.8287C27.2007 19.3029 27.5269 19.6057 27.5235 20.031C27.5171 20.6801 26.745 20.9638 26.0249 20.9766C24.7652 20.9962 24.0346 20.6366 23.4511 20.3652L22.9976 22.4856C23.582 22.7536 24.6641 22.9863 25.784 23C28.4153 22.9999 30.1367 21.6987 30.145 19.688ZM36.6828 22.8471H39L36.978 13.1759H34.8389C34.3582 13.1759 33.9529 13.4559 33.7724 13.8848L30.0159 22.8471H32.6452L33.1671 21.4027H36.381L36.6828 22.8471ZM33.8877 19.4205L35.2067 15.7891L35.9656 19.4205H33.8877ZM23.3501 13.1759L21.2776 22.847H18.7723L20.8453 13.1759H23.3501Z",
    fill: "#1A2ADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6290b6371500ffcf88deb1294bd75e3c.svg";
export { ForwardRef as ReactComponent };